import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isManagement, useAuthenticationService } from '../authentication-service';

export const RequireManager: FC = () => {
  const location = useLocation();
  const [role] = useAuthenticationService(state => [state.role]);
  const isManager = isManagement(role);

  if (!isManager) {
    return <Navigate to={'*'} replace={true} state={{ restore: location.pathname }} />;
  }

  return <Outlet />;
};
